module.exports = __webpack_public_path__ + "img/chukwa.d4603ddf.png";